import { t } from '../../i18n/index.js';
import { Board } from './Board.js';
import { MatchView } from './MatchView.js';
import { PlacementView } from './PlacementView.js';
import { formatDuration } from '../../arena/useArena.js';
import type { BattleshipView, Cell, ShipPlacement } from '../../../shared/games/battleship/index.js';
import type { ArenaResult, GameStateView } from '../../../shared/protocol.js';
import type { ArenaSocket } from '../../realtime.js';

function emit(socket: ArenaSocket, event: 'game:setup' | 'game:move', payload: unknown): Promise<string | null> {
  return new Promise((resolve) =>
    socket.emit(event, payload, (r: ArenaResult) => resolve(r.ok ? null : t.arena.errors[r.error])),
  );
}

/** Battleship UI: placement phase → match. */
export function BattleshipGame(props: { state: GameStateView<BattleshipView>; socket: ArenaSocket; serverNow: number }) {
  const { state, socket, serverNow } = props;

  if (state.status === 'placement') {
    if (!state.me.ready) {
      return (
        <PlacementView
          forbiddenAreaVisible={state.settings.forbiddenAreaVisible}
          deadline={state.placementDeadline ?? serverNow}
          serverNow={serverNow}
          opponentReady={state.opponent.ready}
          onReady={(fleet: ShipPlacement[]) => emit(socket, 'game:setup', { fleet })}
        />
      );
    }
    return (
      <div class="waiting">
        <Board title={t.battleship.ownBoard} ships={(state.module.fleet ?? []).map((ship) => ({ ship, class: 'own' }))} />
        <div class="card waiting-card">
          <p>{t.battleship.waitingOpponent}</p>
          <div class="phase-timer">{formatDuration((state.placementDeadline ?? serverNow) - serverNow)}</div>
        </div>
      </div>
    );
  }

  return <MatchView state={state} serverNow={serverNow} onShoot={(cell: Cell) => emit(socket, 'game:move', cell)} />;
}
